export default __webpack_public_path__ + "static/media/Leggings of the Wells of Night.b0e8a88c.jpg";